<template>
  <div
    class="aside__toggler"
    :class="sidebarAction"
    @click="toggleNav"
  >
    <div class="aside__toggler__body">
      <slot>
        <span></span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isCollapsed() {
      return this.$store.state.layout.navCollapsed;
    },
    sidebarAction() {
      return (this.isCollapsed) ? 'expand' : 'collapse';
    },
    sidebarIndicatorStyle() {
      const degree = (this.isCollapsed) ? 90 : 0;
      return {
        transform: `rotate(${degree}deg)`,
      };
    },
  },
  methods: {
    toggleNav() {
      this.$store.commit('layout/update', {
        navCollapsed: !this.isCollapsed,
      });
    },
  },
};
</script>

<style lang="scss">
$hamburger-width: 24px;
$hamburger-storke-width: 2px;
$hamburger-inner-spacing: 6px;

.aside__toggler {
  height: 60px;
  width: 48px;
}
.aside__toggler__body {
  width: calc(100% - #{$hamburger-inner-spacing});
  height: calc(100% - #{$hamburger-inner-spacing});
  display: flex;
  align-items: center;
  border-radius: 99em;
  justify-content: center;
  margin: 4px;
  cursor: pointer;

  span {
    position: relative;
    top: -$hamburger-storke-width;
  }

  span,
  span::after,
  span::before {
    content: '';
    left: 0;
    border: $hamburger-storke-width solid black;
    display: block;
    width: $hamburger-width;
    box-sizing: border-box;
  }
  span::after,
  span::before {
    position: absolute;
    left: -$hamburger-storke-width;
  }
  span::after { top: $hamburger-inner-spacing; }
  span::before { bottom: $hamburger-inner-spacing; }
}
</style>



// WEBPACK FOOTER //
// src/components/Aside/AsideToggler.vue